import type { DefaultConfigConstants } from '.';

export const DEFAULT_CONFIG: DefaultConfigConstants = {
  maxFiles: Number.POSITIVE_INFINITY,
  maxSize: Number.POSITIVE_INFINITY,
  postponeUpload: false,
} as const;
